import { inject, Injectable } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmHandler } from '../../../components/dialog/dialog.model';
import { DialogService } from '../../../components/dialog/dialog.service';

import { EventDialogComponent } from '../components/event-dialog/event-dialog.component';
import {
  EventDialogCreateData,
  EventDialogData,
  EventDialogEditData,
  EventDialogMode,
  EventDialogResult,
} from '../models/event-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class EventDialogService {
  private readonly _dialog = inject(DialogService);

  open(
    callback: ConfirmHandler<EventDialogResult>,
    initialValue: EventDialogCreateData,
    mode?: 'create'
  ): MatDialogRef<EventDialogComponent>;

  open(
    callback: ConfirmHandler<EventDialogResult>,
    initialValue: EventDialogEditData,
    mode: 'edit' | 'view'
  ): MatDialogRef<EventDialogComponent>;

  open(
    callback: ConfirmHandler<EventDialogResult>,
    initialValue: EventDialogData,
    mode: EventDialogMode = 'create'
  ) {
    return this._dialog.open(
      EventDialogComponent,
      {
        ...initialValue,
        mode,
        onConfirm: callback,
      },
      {
        maxWidth: '560px',
        width: '100%',
      }
    );
  }
}
